import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style.css";
import { API_BASE_URL, DASHBOARD_URL } from "../../config/urls";

const Login = () => {
  const [inputValue, setInputValue] = useState({
    email: "",
    password: "",
  });

  const handleOnChange = (e) => {
    setInputValue({
      ...inputValue,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${API_BASE_URL}/login`,
        inputValue,
      );
      console.log(data);

      if (data.success) {
        localStorage.setItem("token", data.token); // ✅ save token
        toast.success("Login Successful");
        setTimeout(() => {
          window.location.href = `${DASHBOARD_URL}?token=${data.token}`;
        }, 1000);
      } else {
        toast.error(data.message || "Error");
      }
    } catch (err) {
      toast.error("Server Error");
    }
  };
  return (
    <div className="main">
      <div className="form_container">
        <h2>Login Account</h2>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Email</label>
            <input type="email" name="email" onChange={handleOnChange} />
          </div>

          <div>
            <label>Password</label>
            <input type="password" name="password" onChange={handleOnChange} />
          </div>

          <button>Login</button>

          <span>
            Don’t have an account? <Link to="/signup">Signup</Link>
          </span>
        </form>

        <ToastContainer />
      </div>
    </div>
  );
};

export default Login;
